import { useState } from "react";
import {
  BookOpen,
  FileText,
  ChevronDown,
  Network,
  Cable,
  LayoutDashboard,
  School
} from "lucide-react";
import { Link, useLocation } from "react-router-dom";  // ✅ Import

const LeftSidebar = () => {
  const [openMenu, setOpenMenu] = useState(null);
  const location = useLocation();  // ✅ to highlight active links

  const toggleMenu = (menu) => {
    setOpenMenu(openMenu === menu ? null : menu);
  };

  const menuItems = [
    { name: "Dashboard", icon: <LayoutDashboard size={18} />, path: "/inventory" },
    {
      name: "Rooms",
      icon: <School size={18} />,
      children: [
        { name: "Room Equipment", path: "/inventory/room-equipment" },
      ],
    },
    {
      name: "IT Equipment",
      icon: <Network size={18} />,
      children: [
        { name: "CCTV Camera", path: "/inventory/cctv-camera" },
        { name: "Desktop Computer", path: "/inventory/desktop-computer" },
        { name: "Media Equipment", path: "/inventory/media-equipment" },
        { name: "Network Equipment", path: "/inventory/network-equipment" },
        
    
      ],
    },
    {
      name: "Office Equipment",
      icon: <Cable size={18} />,
      children: [
        { name: "Office Computer", path: "/academic/default/set" },
        { name: "Office Equipment", path: "/academic/set/year&term" },
    
      ],
    },
    { name: "Reports", icon: <FileText size={18} />, path: "/academic/reports" },
  ];

  return (
    <aside className="w-64 border-r bg-white shadow h-screen flex flex-col">
      <div className="p-4 border-b font-semibold text-gray-700 text-lg">
      </div>

      <div className="flex-1 overflow-y-auto">
        <ul className="text-sm">
          {menuItems.map((item, idx) => (
            <li key={idx} className="border-b last:border-none p-2">
              {item.children ? (
                <>
                  {/* Parent */}
                  <div
                    onClick={() => toggleMenu(item.name)}
                    className="flex justify-between items-center px-4 py-2 cursor-pointer hover:bg-blue-50 transition text-gray-700"
                  >
                    <div className="flex items-center gap-3">
                      {item.icon}
                      <span className="font-medium">{item.name}</span>
                    </div>
                    <ChevronDown
                      size={16}
                      className={`transform transition ${
                        openMenu === item.name ? "rotate-180" : ""
                      }`}
                    />
                  </div>

                  {/* Children */}
                  {openMenu === item.name && (
                    <ul className="ml-10 text-gray-600">
                      {item.children.map((sub, subIdx) => (
                        <li key={subIdx} className="py-1">
                          <Link
                            to={sub.path}
                            className={`block hover:text-blue-600 transition ${
                              location.pathname === sub.path
                                ? "text-blue-600 font-semibold"
                                : ""
                            }`}
                          >
                            {sub.name}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  )}
                </>
              ) : (
                // Direct Link
                <Link
                  to={item.path}
                  className={`flex items-center gap-3 px-4 py-2 rounded cursor-pointer hover:bg-blue-50 transition text-gray-700 ${
                    location.pathname === item.path
                      ? "bg-blue-100 text-blue-700 font-semibold"
                      : ""
                  }`}
                >
                  {item.icon}
                  <span className="font-medium">{item.name}</span>
                </Link>
              )}
            </li>
          ))}
        </ul>
      </div>
    </aside>
  );
};

export default LeftSidebar;
